var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_1048",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_1048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 8.73047C8.18203 8.73047 7.35938 8.41055 6.71953 7.7707C6.07969 7.13086 5.75977 6.3082 5.75977 5.30273C5.75977 4.29727 6.07969 3.47461 6.71953 2.83477C7.35938 2.19492 8.18203 1.875 9.1875 1.875C10.193 1.875 11.0156 2.19492 11.6555 2.83477C12.2953 3.47461 12.6152 4.29727 12.6152 5.30273C12.6152 6.3082 12.2953 7.13086 11.6555 7.7707C11.0156 8.41055 10.193 8.73047 9.1875 8.73047ZM1.875 16.0658V13.9178C1.875 13.3389 2.01973 12.8438 2.30918 12.4324C2.59863 12.0211 2.97188 11.7088 3.42891 11.4955C4.44961 11.0385 5.42842 10.6957 6.36533 10.4672C7.30225 10.2387 8.24297 10.1244 9.1875 10.1244C10.132 10.1244 11.0689 10.2425 11.9982 10.4786C12.9275 10.7147 13.9019 11.0552 14.9214 11.4999C15.3983 11.7151 15.7806 12.0272 16.0684 12.4361C16.3561 12.845 16.5 13.3389 16.5 13.9178V16.0658H1.875ZM3.24609 14.6947H15.1289V13.9178C15.1289 13.674 15.0565 13.4417 14.9118 13.2208C14.7671 12.9999 14.5881 12.8361 14.3748 12.7295C13.3998 12.2572 12.5086 11.9335 11.7012 11.7583C10.8938 11.5831 10.0559 11.4955 9.1875 11.4955C8.31914 11.4955 7.47363 11.5831 6.65098 11.7583C5.82832 11.9335 4.93711 12.2572 3.97734 12.7295C3.76406 12.8361 3.58887 12.9999 3.45176 13.2208C3.31465 13.4417 3.24609 13.674 3.24609 13.9178V14.6947ZM9.1875 7.35938C9.78164 7.35938 10.2729 7.16514 10.6614 6.77666C11.0499 6.38818 11.2441 5.89687 11.2441 5.30273C11.2441 4.70859 11.0499 4.21729 10.6614 3.82881C10.2729 3.44033 9.78164 3.24609 9.1875 3.24609C8.59336 3.24609 8.10205 3.44033 7.71357 3.82881C7.3251 4.21729 7.13086 4.70859 7.13086 5.30273C7.13086 5.89687 7.3251 6.38818 7.71357 6.77666C8.10205 7.16514 8.59336 7.35938 9.1875 7.35938Z",
    fill: "#8A6CAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.41fab8565ee1151b1660dd8a92a99825.svg";
export { ForwardRef as ReactComponent };